import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { OrderCountByChannelRow } from '@/types/dashboard';
import type { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';
import { isValidTimeZone } from '@/utils/orgCalendar';

type RequestParams = {
  days: number;
  timezone: string;
};

const validate = (params: RequestParams) => {
  if (!Number.isSafeInteger(params.days) || params.days < 1) throw new Error('Days must be a positive safe integer');
  if (!isValidTimeZone(params.timezone)) throw new Error('Valid timezone is required');
};

export const getOrderCountByChannel = async (
  scope: RequestScope,
  params: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<OrderCountByChannelRow[]>> => {
  try {
    validate(params);

    // The backend compares day buckets to a DateTime boundary. Requesting N days normally
    // returns N buckets (N+1 exactly at organization midnight); callers clip to their window.
    const result = await scopedApi(scope).get<EndpointResponse<OrderCountByChannelRow[]>>('metrics/order_count_by_channel', {
      ...options,
      params: { interval: params.days, final: 1, tz: params.timezone },
    });

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
